import { render } from "./TheNavigation.vue?vue&type=template&id=12573a30&ts=true"
import script from "./TheNavigation.vue?vue&type=script&lang=ts"
export * from "./TheNavigation.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/redontrack/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/app/nav/TheNavigation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "12573a30"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('12573a30', __exports__)) {
    console.log('reload')
    api.reload('12573a30', __exports__)
  }
  
  module.hot.accept("./TheNavigation.vue?vue&type=template&id=12573a30&ts=true", () => {
    console.log('re-render')
    api.rerender('12573a30', render)
  })

}


export default __exports__